module.exports = __webpack_public_path__ + "img/4.899a76b2.jpg";